import { useRouteSchedules } from '~/hooks/api/useRouteSchedules';
import { useEditRouteSchedules } from '~/hooks/api/useEditRouteSchedules';
import { useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import RouteScheduleForm from './form';
import messages from './messages';

type RouteScheduleProps = {
  routeId: number;
};

const RouteSchedule = (props: RouteScheduleProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const { data } = useRouteSchedules(props.routeId);
  const editRouteSchedules = useEditRouteSchedules({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.saveSuccess),
      });
    },
  });

  if (!data) return null;
  return data ? (
    <RouteScheduleForm
      routeSchedules={data}
      onSubmit={editRouteSchedules.mutateAsync}
    />
  ) : (
    <div>Loading</div>
  );
};

export default RouteSchedule;
